define('BluePoint.OrderTotalFix.CheckoutOverride',
    [
        'OrderWizard.Module.CartSummary',
        'underscore',
        'jQuery',
        'BluePoint.OrderTotalFix.CheckoutContainer',
        'BluePoint.OrderTotalFix.Utils'
    ],
    function (
        OrderWizardModuleCartSummary,
        _,
        $,
        CheckoutContainer,
        Utils
    ) {

        'use strict';

        _.extend(
            OrderWizardModuleCartSummary.prototype,
            {
                initialize: _.wrap(OrderWizardModuleCartSummary.prototype.initialize, function (fn) {
                        fn.apply(this, _.toArray(arguments).slice(1));

                        var self = this;

                        self.on('afterViewRender', function () {
                            try {
                                var cart = CheckoutContainer.container.getComponent('Cart');

                                if (!cart) {
                                    return;
                                }

                                cart.getLines()
                                    .done(function (lines) {
                                        /*
                                        IMPORTANT:
                                        CHECKOUT LINES RENDER LATE.
                                        WAIT FOR DOM.
                                        */
                                        setTimeout(function () {
                                            /*
                                            CENTRALIZED PRICING
                                            */
                                            var pricingData = Utils.calculateTotals(lines);
                                            var frontendSubtotal = pricingData.frontendSubtotal;
                                            var totalSavings = pricingData.totalSavings;
                                            var nextTierMessage = pricingData.nextTierMessage;

                                            /*
                                            UPDATE CHECKOUT LINE UI
                                            */
                                            _.each(lines, function (line) {

                                                var quantity = Utils.getQuantity(line);
                                                var schedule = Utils.getSchedule(line);

                                                /*
                                                SKIP NON QUANTITY PRICING ITEMS
                                                */
                                                if (!schedule || !schedule.length) {
                                                    return;
                                                }

                                                var tierPrice = Utils.getTierPrice(schedule, pricingData.totalQty);

                                                if (!tierPrice) {
                                                    return;
                                                }

                                                var basePrice = Utils.getBasePrice(schedule);
                                                var newAmount = tierPrice * quantity;
                                                var itemId = line.item && line.item.internalid;

                                                if (!itemId) {
                                                    return;
                                                }

                                                /*
                                                CHECKOUT LINE
                                                */
                                                var $line = $('[data-id="' + itemId + '"]');

                                                if (!$line.length) {
                                                    return;
                                                }

                                                /*
                                                PRICE ELEMENT
                                                */
                                                var $priceLead = $line.find('.transaction-line-views-price-lead').first();

                                                if (!$priceLead.length) {
                                                    return;
                                                }

                                                /*
                                                REMOVE PREVIOUS CUSTOM PRICE
                                                */
                                                $line.find('.bp-checkout-custom-price').remove();

                                                /*
                                                HIDE ORIGINAL PRICE
                                                */
                                                $priceLead.css({
                                                    opacity: '0',
                                                    height: '0',
                                                    display: 'inline-block'
                                                });

                                                var customPriceHtml = '';

                                                /*
                                                DISCOUNT APPLIED
                                                */
                                                if (tierPrice < basePrice) {

                                                    customPriceHtml =
                                                        '<div class="bp-checkout-custom-price" ' +
                                                        'style="margin-top:-18px;">' +
                                                            '<span style="' +
                                                            'font-size:16px;' +
                                                            'font-weight:600;' +
                                                            'color:#000;">' +
                                                                '$' +
                                                                tierPrice.toFixed(2) +
                                                            '</span>' +
                                                            '<span style="' +
                                                            'text-decoration:line-through;' +
                                                            'margin-left:6px;' +
                                                            'color:#999;' +
                                                            'font-size:14px;">' +
                                                                '$' +
                                                                basePrice.toFixed(2) +
                                                            '</span>' +
                                                        '</div>';

                                                } else {
                                                    /*
                                                    NO DISCOUNT
                                                    */
                                                    customPriceHtml =
                                                        '<div class="bp-checkout-custom-price" ' +
                                                        'style="margin-top:-18px;">' +
                                                            '<span style="' +
                                                            'font-size:16px;' +
                                                            'font-weight:600;' +
                                                            'color:#000;">' +
                                                                '$' +
                                                                tierPrice.toFixed(2) +
                                                            '</span>' +
                                                        '</div>';
                                                }

                                                /*
                                                APPEND CUSTOM PRICE
                                                */
                                                $priceLead.after(customPriceHtml);

                                                /*
                                                UPDATE AMOUNT
                                                */
                                                $line.find('.transaction-line-views-cell-navigable-amount')
                                                .html('Amount: $' + newAmount.toFixed(2));
                                            });

                                            /*
                                            UPDATE MINI CART SUBTOTAL
                                            */
                                            $('.header-mini-cart-subtotal-amount').html(
                                                    '<span class="header-mini-cart-subtotal-amount-text">' +
                                                    'Subtotal' +
                                                    '</span> ' +
                                                    '$' +
                                                    frontendSubtotal.toFixed(2)
                                                );

                                            /*
                                            MINI CART SAVINGS
                                            */
                                            if ($('.bp-mini-savings').length === 0) {

                                                $('.header-mini-cart-subtotal-amount').after(
                                                        '<div class="bp-mini-savings" ' +
                                                        'style="color:green;font-size:12px;margin-top:5px;">' +
                                                        'You saved $' +
                                                        totalSavings.toFixed(2) +
                                                        '</div>'
                                                    );

                                            } else {
                                                $('.bp-mini-savings').html('You saved $' + totalSavings.toFixed(2));
                                            }

                                            /*
                                            UPDATE CHECKOUT SUBTOTAL
                                            */
                                            self.$el
                                                .find('.order-wizard-cart-summary-subtotal .order-wizard-cart-summary-grid-right')
                                                .first().html('$' + frontendSubtotal.toFixed(2));

                                            /*
                                            UPDATE CHECKOUT TOTAL
                                            */
                                            cart.getSummary().done(function (summary) {
                                                var discount = Math.abs(parseFloat(summary.discounttotal || 0));
                                                self.$el
                                                    .find('.order-wizard-cart-summary-total .order-wizard-cart-summary-grid-right')
                                                    .first().html('$' + (frontendSubtotal - discount).toFixed(2));
                                            });

                                            /*
                                            SAVINGS MESSAGE
                                            */
                                            if (self.$el.find('.bp-checkout-savings').length === 0) {
                                                
                                                self.$el
                                                    .find('.order-wizard-cart-summary-total')
                                                    .after(
                                                        '<div class="bp-checkout-savings" ' +
                                                        'style="margin-top:15px;color:green;font-weight:bold;">' +
                                                        'You saved $' +
                                                        totalSavings.toFixed(2) +
                                                        ' on this order.' +
                                                        '</div>'
                                                    );

                                            } else {
                                                self.$el
                                                    .find('.bp-checkout-savings')
                                                    .html('You saved $' + totalSavings.toFixed(2) + ' on this order.');
                                            }

                                            /*
                                            NEXT TIER MESSAGE
                                            */
                                            if (nextTierMessage) {
                                                if (self.$el.find('.bp-checkout-next-tier').length === 0) {
                                                    
                                                    self.$el.find('.bp-checkout-savings').after(
                                                            '<div class="bp-checkout-next-tier" ' +
                                                            'style="margin-top:10px;color:#d97706;font-weight:600;">' +
                                                            nextTierMessage +
                                                            '</div>'
                                                        );

                                                } else {
                                                    self.$el.find('.bp-checkout-next-tier').html(nextTierMessage);
                                                }

                                            } else {
                                                self.$el.find('.bp-checkout-next-tier').remove();
                                            }

                                        }, 2000);
                                    });

                            } catch (e) {
                                console.log('Checkout Override Error =====>', e);
                            }
                        });
                    }
                )
            }
        );
    }
);
